<template>
  <div :class="'stat-size-' + size">
    <div
      v-tippy="{
        content: $t(
          getDictionaryItem('callAgentBadges', badge).localeKey,
          getDictionaryItem('callAgentBadges', badge).localePluralIndex
        )
      }"
      class="stat-container border-[3px] rounded-full"
      :style="{ 'border-color': getDictionaryItem('callAgentBadges', badge).ringColor }"
    >
      <div class="stat-text w-full h-full">
        {{ modelValue }}
      </div>
      <div class="stat-icon-container bg-tertiary">
        <Icon
          :type="getDictionaryItem('callAgentBadges', badge).icon"
          class="stat-icon w-full h-full flex items-center justify-center"
          :style="{ color: getDictionaryItem('callAgentBadges', badge).iconColor }"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Icon from '@/components/icon/Icon.vue'

import { getDictionaryItem } from '@/dictionary'

defineProps({
  modelValue: {
    type: Number,
    default: null
  },
  badge: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'md' // sm, md, lg
  }
})
</script>

<style>
.stat-container {
  position: relative;
}

.stat-size-sm .stat-container {
  width: 2.5rem;
  height: 2.5rem;
}

.stat-size-md .stat-container {
  width: 3rem;
  height: 3rem;
}

.stat-size-lg .stat-container {
  width: 3.5rem;
  height: 3.5rem;
}

.stat-size-sm .stat-text {
  font-size: var(--text-md);
}

.stat-size-md .stat-text {
  font-size: var(--text-lg);
}

.stat-size-lg .stat-text {
  font-size: var(--text-xl);
}

.stat-text {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 500;
}

.stat-text:hover {
  cursor: default;
}

.stat-icon-container {
  position: absolute;
  border: 2px solid white;
  border-radius: 100%;
}

.dark .stat-icon-container {
  border-color: slategray;
}

.stat-size-sm .stat-icon-container {
  width: 1.75rem;
  height: 1.75rem;
  bottom: -8px;
  right: -17px;
}

.stat-size-md .stat-icon-container {
  width: 2rem;
  height: 2rem;
  bottom: -8px;
  right: -17px;
}

.stat-size-lg .stat-icon-container {
  width: 2rem;
  height: 2rem;
  bottom: -8px;
  right: -17px;
}

.stat-size-sm .stat-icon {
  font-size: var(--text-sm);
}

.stat-size-md .stat-icon {
  font-size: var(--text-md);
}

.stat-size-lg .stat-icon {
  font-size: var(--text-lg);
}
</style>
